if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.form) {
          this.form.addEventListener(
            'submit',
            this.onSubmitHandler.bind(this)
          );
        }

        this.variantIdInput =
          this.form?.querySelector('[name="id"]');

        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }

        if (this.submitButton) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }
      }

      /*
       * CHECK WHETHER THIS IS THE
       * CUSTOM VEHICLE KEYCHAIN
       */

      isBOGOProduct() {
        const productForm =
          this.closest(
            '[data-product-id]'
          );

        const productTitle =
          document.title.toLowerCase();

        const pageText =
          document.body.innerText.toLowerCase();

        return (
          productTitle.includes(
            'custom vehicle keychain'
          ) ||
          pageText.includes(
            'custom vehicle keychain'
          )
        );
      }


      /*
       * SHOW BOGO POPUP
       */

      showBOGOPopup() {
        return new Promise((resolve) => {

          /*
           * Prevent duplicate popup
           */

          const existing =
            document.querySelector(
              '#sl-bogo-popup'
            );

          if (existing) {
            existing.remove();
          }


          const popup =
            document.createElement(
              'div'
            );

          popup.id =
            'sl-bogo-popup';


          popup.innerHTML = `

            <div class="sl-bogo-overlay">

              <div
                class="sl-bogo-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="sl-bogo-title"
              >

                <button
                  type="button"
                  class="sl-bogo-close"
                  aria-label="Close"
                >
                  ×
                </button>


                <div class="sl-bogo-eyebrow">
                  LIMITED TIME OFFER
                </div>


                <div class="sl-bogo-icon">
                  2×
                </div>


                <h2 id="sl-bogo-title">
                  Buy 1, Get 1 FREE
                </h2>


                <p class="sl-bogo-main-text">
                  You're getting <strong>2 identical
                  Custom Vehicle Keychains</strong>
                  for the price of one.
                </p>


                <p class="sl-bogo-subtext">
                  Your second keychain will be made
                  with the exact same number and
                  customization.
                </p>


                <div class="sl-bogo-actions">

                  <button
                    type="button"
                    class="sl-bogo-accept"
                  >
                    Yes, Give Me 2
                  </button>


                  <button
                    type="button"
                    class="sl-bogo-decline"
                  >
                    No Thanks
                  </button>

                </div>


                <div class="sl-bogo-note">
                  Limited-time offer • Same customization
                </div>

              </div>

            </div>

          `;


          document.body.appendChild(
            popup
          );


          /*
           * LOCK SCROLL
           */

          document.body.classList.add(
            'sl-bogo-active'
          );


          /*
           * ADD STYLES
           */

          if (
            !document.querySelector(
              '#sl-bogo-styles'
            )
          ) {

            const style =
              document.createElement(
                'style'
              );

            style.id =
              'sl-bogo-styles';


            style.textContent = `

              #sl-bogo-popup {
                position: fixed;
                inset: 0;
                z-index: 999999;
              }


              .sl-bogo-overlay {
                position: absolute;
                inset: 0;

                display: flex;
                align-items: center;
                justify-content: center;

                padding: 20px;

                background:
                  rgba(0,0,0,0.72);

                backdrop-filter:
                  blur(8px);

                -webkit-backdrop-filter:
                  blur(8px);
              }


              .sl-bogo-modal {
                position: relative;

                width: 100%;
                max-width: 460px;

                padding: 42px 32px 30px;

                background: #ffffff;

                color: #111111;

                border-radius: 20px;

                text-align: center;

                box-shadow:
                  0 25px 80px
                  rgba(0,0,0,0.30);

                animation:
                  slBogoIn
                  0.25s ease;
              }


              @keyframes slBogoIn {

                from {
                  opacity: 0;
                  transform:
                    translateY(15px)
                    scale(.97);
                }

                to {
                  opacity: 1;
                  transform:
                    translateY(0)
                    scale(1);
                }

              }


              .sl-bogo-close {
                position: absolute;

                top: 12px;
                right: 14px;

                width: 34px;
                height: 34px;

                border: 0;

                background: transparent;

                color: #777777;

                font-size: 27px;

                line-height: 1;

                cursor: pointer;
              }


              .sl-bogo-close:hover {
                color: #111111;
              }


              .sl-bogo-eyebrow {
                margin-bottom: 15px;

                font-size: 11px;

                font-weight: 800;

                letter-spacing: 1.8px;

                color: #666666;
              }


              .sl-bogo-icon {
                width: 58px;
                height: 58px;

                display: flex;

                align-items: center;
                justify-content: center;

                margin: 0 auto 18px;

                background: #111111;

                color: #ffffff;

                border-radius: 50%;

                font-size: 17px;

                font-weight: 800;
              }


              .sl-bogo-modal h2 {
                margin: 0 0 12px;

                font-size: 30px;

                line-height: 1.15;

                font-weight: 800;

                letter-spacing: -0.5px;
              }


              .sl-bogo-main-text {
                margin: 0 auto 10px;

                max-width: 370px;

                color: #333333;

                font-size: 15px;

                line-height: 1.55;
              }


              .sl-bogo-main-text strong {
                color: #111111;
              }


              .sl-bogo-subtext {
                margin: 0 auto;

                max-width: 350px;

                color: #777777;

                font-size: 13px;

                line-height: 1.5;
              }


              .sl-bogo-actions {
                display: flex;

                flex-direction: column;

                gap: 9px;

                margin-top: 26px;
              }


              .sl-bogo-accept,
              .sl-bogo-decline {
                width: 100%;

                min-height: 50px;

                border-radius: 10px;

                font-size: 14px;

                font-weight: 700;

                cursor: pointer;

                transition:
                  transform .2s ease,
                  background .2s ease;
              }


              .sl-bogo-accept {
                border: 1px solid #111111;

                background: #111111;

                color: #ffffff;
              }


              .sl-bogo-accept:hover {
                background: #333333;

                transform:
                  translateY(-1px);
              }


              .sl-bogo-decline {
                border: 1px solid #dddddd;

                background: #ffffff;

                color: #555555;
              }


              .sl-bogo-decline:hover {
                border-color: #111111;

                color: #111111;
              }


              .sl-bogo-note {
                margin-top: 17px;

                color: #999999;

                font-size: 10px;

                letter-spacing: .3px;
              }


              body.sl-bogo-active {
                overflow: hidden;
              }


              @media screen and (max-width: 749px) {

                .sl-bogo-overlay {
                  padding: 16px;
                }


                .sl-bogo-modal {
                  max-width: 100%;

                  padding:
                    35px
                    22px
                    24px;

                  border-radius: 18px;
                }


                .sl-bogo-modal h2 {
                  font-size: 25px;
                }


                .sl-bogo-main-text {
                  font-size: 14px;
                }


                .sl-bogo-subtext {
                  font-size: 12px;
                }


                .sl-bogo-actions {
                  margin-top: 22px;
                }

              }

            `;

            document.head.appendChild(
              style
            );

          }


          /*
           * CLEANUP
           */

          const cleanup =
            (result) => {

              document.body.classList.remove(
                'sl-bogo-active'
              );

              popup.remove();

              resolve(result);

            };


          /*
           * YES
           */

          popup
            .querySelector(
              '.sl-bogo-accept'
            )
            .addEventListener(
              'click',
              () => cleanup(true)
            );


          /*
           * NO
           */

          popup
            .querySelector(
              '.sl-bogo-decline'
            )
            .addEventListener(
              'click',
              () => cleanup(false)
            );


          /*
           * CLOSE
           */

          popup
            .querySelector(
              '.sl-bogo-close'
            )
            .addEventListener(
              'click',
              () => cleanup(false)
            );


          /*
           * CLICK OUTSIDE
           */

          popup
            .querySelector(
              '.sl-bogo-overlay'
            )
            .addEventListener(
              'click',
              (event) => {

                if (
                  event.target.classList.contains(
                    'sl-bogo-overlay'
                  )
                ) {
                  cleanup(false);
                }

              }
            );


          /*
           * ESCAPE
           */

          const escapeHandler =
            (event) => {

              if (
                event.key === 'Escape'
              ) {

                document.removeEventListener(
                  'keydown',
                  escapeHandler
                );

                cleanup(false);

              }

            };


          document.addEventListener(
            'keydown',
            escapeHandler
          );

        });
      }


      async onSubmitHandler(event) {
  event.preventDefault();
  event.stopPropagation();

  if (!this.form || !this.submitButton) return;

  /*
   * =========================================
   * SNAPPYLAYERS BOGO
   * =========================================
   *
   * Only trigger on Custom Vehicle Keychain.
   *
   * The popup will appear BEFORE Shopify
   * adds anything to the cart.
   */

  if (
    window.location.pathname
      .toLowerCase()
      .includes('/products/custom-vehicle-keychain') &&
    this.form.dataset.slBogoApproved !== 'true'
  ) {
    if (typeof window.SL_OPEN_BOGO === 'function') {

      window.SL_OPEN_BOGO(this.form);

      return;
    }
  }


  /*
   * =========================================
   * NORMAL SHOPIFY ADD TO CART
   * =========================================
   */

  if (
    this.submitButton.disabled ||
    this.submitButton.getAttribute('aria-disabled') === 'true'
  ) {
    return;
  }

  this.handleErrorMessage();

  this.submitButton.setAttribute(
    'aria-disabled',
    'true'
  );

  this.submitButton.classList.add(
    'loading'
  );

  const spinner =
    this.querySelector('.loading__spinner');

  if (spinner) {
    spinner.classList.remove('hidden');
  }


  try {

    const formData =
      new FormData(this.form);


    const variantId =
      formData.get('id');


    if (!variantId) {
      throw new Error(
        'Product variant was not found.'
      );
    }


    formData.append(
      'sections',
      'cart-drawer'
    );


    formData.append(
      'sections_url',
      window.location.pathname
    );


    const addResponse =
      await fetch(
        window.routes.cart_add_url,
        {
          method: 'POST',

          headers: {
            'X-Requested-With':
              'XMLHttpRequest',

            Accept:
              'application/json'
          },

          body: formData
        }
      );


    const addData =
      await addResponse.json();


    if (
      !addResponse.ok ||
      addData.status
    ) {

      throw new Error(
        addData.description ||
        addData.message ||
        'Unable to add product to cart.'
      );

    }


    await this.loadCartDrawer();


  } catch (error) {

    console.error(
      'SNAPPYLAYERS CART ERROR:',
      error
    );


    this.handleErrorMessage(
      error.message ||
      'Unable to add product to cart.'
    );


  } finally {

    this.submitButton.classList.remove(
      'loading'
    );

    this.submitButton.removeAttribute(
      'aria-disabled'
    );


    if (spinner) {
      spinner.classList.add('hidden');
    }

  }
}


      async loadCartDrawer() {

        const response =
          await fetch(
            `${window.routes.cart_url}?section_id=cart-drawer`,
            {
              method: 'GET',

              headers: {
                'X-Requested-With':
                  'XMLHttpRequest',

                Accept:
                  'text/html',
              },
            }
          );


        if (!response.ok) {

          throw new Error(
            'Unable to load cart drawer.'
          );

        }


        const html =
          await response.text();


        const parser =
          new DOMParser();


        const documentHTML =
          parser.parseFromString(
            html,
            'text/html'
          );


        const newDrawer =
          documentHTML.querySelector(
            'cart-drawer'
          );


        if (newDrawer) {

          const oldDrawer =
            document.querySelector(
              'cart-drawer'
            );


          if (oldDrawer) {

            oldDrawer.replaceWith(
              newDrawer
            );

          } else {

            document.body.appendChild(
              newDrawer
            );

          }

        } else {

          throw new Error(
            'Shopify did not return the cart drawer section.'
          );

        }


        const drawer =
          document.querySelector(
            'cart-drawer'
          );


        if (!drawer) {

          throw new Error(
            'Cart drawer could not be inserted.'
          );

        }


        const overlay =
          drawer.querySelector(
            '#CartDrawer-Overlay'
          );


        if (overlay) {

          overlay.addEventListener(
            'click',
            () => drawer.close()
          );

        }


        if (
          typeof drawer.open ===
          'function'
        ) {

          drawer.open(
            this.submitButton
          );

        } else {

          drawer.classList.add(
            'animate',
            'active'
          );


          document.body.classList.add(
            'overflow-hidden'
          );

        }


        this.updateCartBubble();

      }


      async updateCartBubble() {

        try {

          const response =
            await fetch(
              `${window.routes.cart_url}?section_id=cart-icon-bubble`,
              {
                headers: {
                  'X-Requested-With':
                    'XMLHttpRequest',
                },
              }
            );


          if (!response.ok) return;


          const html =
            await response.text();


          const parser =
            new DOMParser();


          const doc =
            parser.parseFromString(
              html,
              'text/html'
            );


          const newBubble =
            doc.querySelector(
              '#cart-icon-bubble'
            );


          const oldBubble =
            document.querySelector(
              '#cart-icon-bubble'
            );


          if (
            newBubble &&
            oldBubble
          ) {

            oldBubble.innerHTML =
              newBubble.innerHTML;

          }

        } catch (error) {

          console.error(
            'Cart bubble update error:',
            error
          );

        }

      }


      handleErrorMessage(
        message = false
      ) {

        if (this.hideErrors) return;


        const wrapper =
          this.querySelector(
            '.product-form__error-message-wrapper'
          );


        if (!wrapper) return;


        const errorMessage =
          wrapper.querySelector(
            '.product-form__error-message'
          );


        wrapper.toggleAttribute(
          'hidden',
          !message
        );


        if (
          errorMessage &&
          message
        ) {

          errorMessage.textContent =
            message;

        }

      }

    }
  );
}